import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22theme.js%22,%22import%22:%22Roboto_Serif%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22display%22:%22swap%22,%22preload%22:false,%22fallback%22:[%22ui-serif%22,%22Georgia%22,%22Cambria%22,%22Times%20New%20Roman%22,%22Times%22,%22serif%22]}],%22variableName%22:%22ROBOTO_SERIF%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Roboto Serif', ui-serif, Georgia, Cambria, Times New Roman, Times, serif",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
